import { apiClient } from "@apis/apiClient";


/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  updateSetting(data: any) {
    return apiClient.post(`/rest/uiSetting`, data);
  },

  findOne(pageName: any) {
    return apiClient.get(`/rest/uiSetting/${pageName}`);
  },
};
